import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAddresses } from '../../modules/addresses/types/Adresses';

interface AddressState {
  items: IAddresses[];
  selectedAddressId?: string;
  loading: boolean;
  error: string | null;
}

const initialState: AddressState = {
  items: [],
  selectedAddressId: localStorage.getItem('address') || '',
  loading: false,
  error: null,
};

const addressSlice = createSlice({
  name: 'addresses',
  initialState,
  reducers: {
    setAddresses(state, action: PayloadAction<IAddresses[]>) {
      state.items = action.payload;
    },
    addAddress(state, action: PayloadAction<IAddresses>) {
      state.items.push(action.payload);
    },
    updateAddress(state, action: PayloadAction<IAddresses>) {
      const index = state.items.findIndex(
        addr => addr._id === action.payload._id
      );
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    removeAddress(state, action: PayloadAction<string>) {
      state.items = state.items.filter(addr => addr._id !== action.payload);
    },
    setSelectedAddress(state, action: PayloadAction<string | undefined>) {
      state.selectedAddressId = action.payload;
      localStorage.setItem('address', action.payload || '');
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setAddresses,
  addAddress,
  updateAddress,
  removeAddress,
  setSelectedAddress,
  setLoading,
  setError,
} = addressSlice.actions;

export default addressSlice.reducer;
